/**
 * Builds the payload for POST/PUT to /api/ChannelDependency.
 *
 * The rule that must hold: parentFlag is ALWAYS false on the wire, regardless
 * of which original channel was picked or what the channel's isParentChannel
 * attribute says. The earlier behaviour derived parentFlag from the selected
 * channel's isParentChannel — that produced inconsistent backend handling for
 * dependencies whose original channel happened to be a parent. Pinning the
 * value to false here removes that ambiguity at source.
 *
 * alignmentType is also fixed at 2 — that's the only value the admin portal
 * has ever sent and the backend treats it as the channel-dependency alignment.
 *
 * Anything else in the form (originalChannelId, originalValue, dependentChannelId,
 * dependentValue, id when present) is passed through verbatim.
 */
export function buildChannelDependencyPayload (form) {
	return {
		...form,
		parentFlag: false,
		alignmentType: 2
	}
}
